
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

// 初始化提供的模板
import { IOrderForm } from '@/types/placeOrderTypes'
import _ from 'lodash'
import { ICustomerAppKey, IOrganization, IUser } from '@/store/state'
import { Action, Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { IServiceMap } from '@/business/BusinessFormData'
import { editOrder, getOrder, submitOrder } from '@/api/placeOrder'
import OrderCheckMessage from './components/OrderCheckMessage.vue'
import { ServiceContentEnum } from '@/business/ServiceContent'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'BasePage',
  components: {
    OrderCheckMessage,
  },
})
export default class PlaceOrder extends Vue {
  @Action('setOrderId') setOrderId!: (id: string) => void
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('order_id') order_id!: string
  @Getter('user') user!: IUser
  @Getter('formMap')
  formMap!: IFormMap

  @Prop({ default: () => ({} as IOrderForm) }) form!: IOrderForm
  @Prop({ default: false }) reEdit!: boolean
  @Prop({}) name!: string
  @Prop({}) formInfo!: IServiceMap
  @Prop({}) defaultForm!: IOrderForm

  buttonLoading: boolean = false
  loading: boolean = false

  fromPage: string = 'service'

  get isFree() {
    return this.user?.orgs[0]?.isFree === 1
  }

  @Watch('$route.query.id', { immediate: true, deep: true })
  getId() {
    this.setOrderId(this.$route.query.id as string)
    if (!this.$route.query.id) {
      this.$emit('form-change', _.cloneDeep(this.defaultForm))
    }
  }

  created() {
    this.reEdit = !!this.$route.query.reEdit
  }

  async mounted() {
    const { serviceType, name, from } = this.$route.params
    this.fromPage = from

    this.$emit('base-mounted', serviceType, name)
    await this.init()

    // trick: 防止别的组件刷新之后replace页面
    ;(this as any).$updateQuery({
      fbd_config_visible: '0',
    })
  }

  async init() {
    // 初始化表单数据
    const initForm = this.order_id ? await getOrder({ ticket_id: this.order_id }) : _.cloneDeep(this.defaultForm)
    this.$emit('form-change', initForm)
    this.loading = true

    // 初始化后自定义操作
    this.$emit('init-completed')
  }

  submitCheckForm(form: IOrderForm) {
    if (!form.book_name && this.form?.service_content !== ServiceContentEnum.PptToEnbx)
      return this.$message.error('请输入图书名称')
    if (!form.alias && this.form?.service_content !== ServiceContentEnum.PptToEnbx)
      return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!form.customer_id) return this.$message.error('请选择客户')
    if (!form.app_key) return this.$message.error('请选择AppKey')
    if (!form.deadline) return this.$message.error('请输入承诺完成时间')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) return this.$message.error('工单别名含有非法字符')
    if (!this.form.xdoc_planning.length && this.form.service_content !== ServiceContentEnum.PptToEnbx)
      return this.$message.error('请确认工单信息是否完全')

    // 自定义表单验证规则
    let res = undefined
    this.$emit('check-form', '', (val: boolean) => {
      res = val
    })
    if (res !== undefined) return res
  }

  debounceSubmit = _.debounce(this.submit, 500)
  async submit() {
    if (this.submitCheckForm(this.form)) return
    // 触发提交前事件
    this.$emit('before-submit', this.form)

    const formData = _.cloneDeep({ ticket_id: this.order_id, ...this.screenForm(this.form) })
    if (formData.service_content !== ServiceContentEnum.WordToPpt) {
      if (formData.xdoc_planning.length && formData.alias) {
        formData.xdoc_planning.map((plan: any) => {
          plan.config!.book_type = plan.name.split(formData.alias + '-').join('')
        })
      }
    }
    if (formData.service_content === 19) {
      formData.delivery = 16;
      formData.status = 0;
      formData.file_name = formData?.book_name || '';
      formData.xdoc_planning.origin_files = [];
      for (let index in formData.material.oss_json_files) {
        if (index < formData.xdoc_planning[0].origin_files.length) {
          formData.xdoc_planning[0].origin_files[index].json_data = formData.material.oss_json_files.find((item: any) => item.name === formData.xdoc_planning[0].origin_files[index].name)?.json_data;
        }
        formData.material.oss_json_files[index].style_id = formData.xdoc_planning[0].config!.style_id;
      }
      formData.callback_data = { callback_url: 'http://worksheet.hexinedu.com/api/open/ticket/v1/callback/test' };
      delete formData.xdoc_planning[0].config.style_config_name;
      delete formData.xdoc_planning[0].config.vba_url;
      delete formData.xdoc_planning[0].config.style_config_data;
    }

    // 对formData进行处理
    this.$emit('before-send', formData)
    await this.handleSend(formData)
  }

  async handleSend(formData: any) {
    try {
      this.buttonLoading = true
      formData.material.content_desc =
        this.formInfo?.category === 'digitization'
          ? formData.material.content_desc
          : formData.material.courseware_sample_desc

      formData.is_free = this.isFree
      await editOrder(formData)
      if (!this.reEdit) await submitOrder({ ticket_id: this.order_id })
      else {
        this.$message.success('修改成功')
        await this.$router.push('/order')
        return
      }
      this.$message.success('下单成功')
      await this.$router.push(`/success?id=${this.order_id}`)
    } catch (error) {
      this.$message.error(`下单出现异常，原因：${(error as any).message || error}，联系客户经理解决`)
    } finally {
      this.buttonLoading = false
    }
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }

  async back() {
    // if (this.order_id) await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
    if (this.fromPage === 'service_by_tool') {
      this.$router.push('/service_by_tool')
    } else {
      this.$router.push('/service')
    }
  }
}
